// extracted by mini-css-extract-plugin
module.exports = {"signUpPage":"StepperComposer_signUpPage__Qv4Zr"};